<template>
  <div class="flex gap-4 items-center" v-if="mode == 'input'">
    <span
      class="border-[#527A6B] border-[1.5px] text-white uppercase inline-flex items-center rounded-[12px] justify-center w-18 h-18 heightMd:h-12 heightMd:w-12 font-bold heightMd:text-lg text-2xl"
      :class="{ 'border-cw-navy-light': letters[index] }"
      v-for="(item, index) in size"
      :key="item"
    >
      {{ letters[index] }}
    </span>
    <a href="" @click.prevent="emit('deleteLetter')" class="hover:text-cw-navy-light">
      <BackSpaceIcon class="w-10 h-auto ml-5" />
    </a>
  </div>
  <div class="flex gap-4" v-if="mode == 'selection'">
    <a
      href=""
      @click.prevent="selectLetter(letter)"
      class="border-cw-navy-light border-[1.5px] uppercase inline-flex items-center rounded-[12px] justify-center w-18 h-18 heightMd:h-12 heightMd:w-12 font-bold heightMd:text-lg text-2xl transform transition-all duration-200 hover:scale-105"
      :class="[selectedLetter === letter ? 'bg-white text-cw-green-dark' : 'bg-cw-green-dark text-white', { 'cursor-not-allowed': isDisabled }]"
      v-for="letter in letters"
      :key="letter"
    >
      {{ letter }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import BackSpaceIcon from '@/assets/svgs/icons/backspace.svg'
const emit = defineEmits(['letterSelected', 'deleteLetter'])

const {
  size = 6,
  letters = '',
  defaultLetter = '',
  mode = 'input',
  isDisabled = false
} = defineProps<{
  defaultLetter?: string
  letters?: string
  size?: number
  mode: 'input' | 'selection'
  isDisabled?: boolean
}>()

const selectedLetter = ref(defaultLetter)

function selectLetter(letter: string) {
  if (isDisabled) return
  selectedLetter.value = letter
  emit('letterSelected', letter)
}
</script>

<style scoped></style>
